module.exports = __webpack_public_path__ + "static/img/1.308f40d1.png";